import React from 'react';

import { Container, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Container data-testid="notFoundPage">
      <Box className={classes.wrapper}>
        <Typography variant="h1">{t('page.notFound.error')}</Typography>
        <Typography variant="h3">{t('page.notFound.errorTitle')}</Typography>
        <Typography align="center">{t('page.notFound.errorDescription')}</Typography>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
